import { environment } from 'src/environments/environment';
export const baseUrl = environment.baseUrl;
export const demoReqinfo = baseUrl + '/schoolWebsite/demoReq';
export const addInstitution = baseUrl + '/schoolWebsite/addinstitute';
export const contactUs = baseUrl + '/schoolWebsite/contUs';
export const getModuleList = baseUrl + '/module/getAllModules';
export const fileDownload= baseUrl + "/file/download";
export const fileUpload= baseUrl + "/file/upload";
export const getNewsList= baseUrl + "/news/list";
export const getNewsById= baseUrl + "/news/by";
export const getNewsByCate= baseUrl + "/news/By";
export const addLeadReq= baseUrl + "/leads/add";
export const getFaqByStatus=baseUrl+ "/faq/by/status";
export const getSchooByUrl=baseUrl+ "/admin/school/weburl";
